import { VBtn } from 'vuetify/lib/components/VBtn';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "error-container"
  }, [_c("h2", [_vm._v(_vm._s(_vm.heyror.title))]), _c("div", [_vm.heyror.descriptionHtml ? _c("div", {
    staticClass: "customDesc",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.heyror.descriptionHtml))
    }
  }) : _vm.heyror.description ? _c("div", {
    staticClass: "customDesc"
  }, [_vm._v(_vm._s(_vm.heyror.description))]) : _c("div", [_vm._v("The page you are looking for is not available.")]), (!_vm.loggedUserData || _vm.loggedUserData.userGroup !== "ADMIN") && _vm.heyror.customerServices != false ? _c("div", [_vm._v(" Please contact our "), _c("a", {
    attrs: {
      href: _vm.customerServiceLink
    }
  }, [_vm._v("Customer Services.")])]) : _vm._e()]), _c(VBtn, {
    class: ["dfwa-btn --small", _vm.darkBg ? "--with-dark-bg" : ""],
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.goToLink();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.heyror.linkTitle) + " ")])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };